import React, { useMemo, useState, useEffect } from 'react'
import {
  makeStyles,
  Box,
  Button,
  // FormControl,
  // Select,
  // MenuItem,
} from '@material-ui/core'
// import ToggleButtonGroup from '@material-ui/button';
import FaqItem from 'src/mobile/components/FaqItem'
import FaqSearch from 'src/mobile/components/FaqSearch'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next'
import { getFaqList, getFaqTypeList } from 'src/store/slices/docSlice'
import FaqLoading from 'src/mobile/components/FaqLoading'
import { useCustomTranslation } from 'src/hooks'
import TopStickyBar from 'src/mobile/layout/TopStickyBar'
import { contentClick } from 'src/utils/trackingCode'
import { Helmet  } from 'react-helmet'

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Inter',
    '& .MuiButton-label': {
      fontFamily: 'Inter',
    },
  },
  bar: {
    width: '100%',
    border: '1px solid #AFB1B5',
    height: theme.spacing(7),
    borderRadius: 8,
    padding: theme.spacing(1.25),
    paddingLeft: theme.spacing(2.15),
  },
  bar1: {
    fontSize: 16,
  },
  title: {
    paddingLeft: theme.spacing(2.15),
    height: 27,
    color: '#F2512D',
    fontWeight: 600,
    lineHeight: '150%',
    fontSize: 18,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  searchResult: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    fontWeight: 400,
    fontSize: 16,
  },
  searchResultlength: {
    display: 'inline-block',
    fontWeight: 600,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  selectbtn: {
    backgroundColor: '#F9FAFB',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: 14,
    padding: '11.5px 16px',
  },
  selectbtnRed: {
    '& .MuiButton-root': {
      '&:hover': {
        backgroundColor: '#F2512D',
      },
    },
    backgroundColor: '#F2512D',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: 14,
    padding: '11.5px 16px',
    color: 'white',
  },
}))

const FAQ = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()
  const { faqList: allFaqList, faqListStatus } = useSelector((state) => state.doc)
  const [faqList, setFaqList] = useState([])
  const [activePanel, setActivePanel] = useState(null)
  const { faqTypeList: allFaqTypeList, faqListTypeStatus } = useSelector((state) => state.doc)
  const [activeType, setActiveType] = useState('')
  const [selectShow, setSelectShow] = useState(true)
  const [clearbtn, setclearbtn] = useState(false)
  const [classificationFaqList, setClassificationFaqList] = useState([])
  const changeselectShow = (e) => setSelectShow(e)
  const handleChange = (index) => {
    if(index){
      const question = faqList.filter((ele)=>(ele.id === Number(index)))
      if(question.length>0){
        contentClick('EH_FAQ', 'EN_FAQ', question[0].questionHk)
      }
    }
    setActivePanel(index)
  }
  const [query, setQuery] = useState('')
  const changeclearbtn = (e) => {
    setclearbtn(e)
  }
  const handleSearchResult = (result, query) => {
    if (faqListTypeStatus === 'fulfilled') {
      setActiveType(allFaqTypeList[0][tB('name')])
    }
    setFaqList(result)
    fun(result)
    setQuery(query)
  }
  const allTypeList = useMemo(() => {
    return [].concat(
      allFaqTypeList?.map((item, index) => ({
        label: item[tB('name')],
        value: item[tB('name')],
        id: item.id,
        selected: false,
        index: index,
      })) || [],
    )
  }, [allFaqTypeList])
  const handleFilter = (e) => {
    contentClick('EH_FAQ', 'EN_FAQ', e?.target?.value)
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    setActiveType(e)
  }
  const Bar = () => {
    return (
      <Box margin="0 auto">
        <Box value={activeType}>
          {allTypeList.map((item, index) => (
            <Button
              className={item.label === activeType ? classes.selectbtnRed : classes.selectbtn}
              key={item.id}
              value={item.value}
              onClick={() => {
                handleFilter(item.value)
              }}
            >
              {t(item.label)}
            </Button>
          ))}
        </Box>
      </Box>
    )
  }
  const fun = (e) => {
    const classificationFaqList = {
      length: 0,
      classificationFaqList: [],
    }
    for (let i = 0; i < allTypeList.length; i++) {
      classificationFaqList.classificationFaqList.push({
        id: allTypeList[i].id,
        label: allTypeList[i].label,
        list: [],
      })
    }
    if (e && e?.length > 0) {
      for (let i = 0; i < classificationFaqList.classificationFaqList.length; i++) {
        for (let j = 0; j < e?.length; j++) {
          if (classificationFaqList.classificationFaqList[i].id === e[j].questionType) {
            classificationFaqList.classificationFaqList[i].list.push(e[j])
            classificationFaqList.length += 1
          }
        }
      }
    }
    setClassificationFaqList(classificationFaqList)
  }
  useEffect(() => {
    dispatch(getFaqList())
    dispatch(getFaqTypeList())
    if (faqListTypeStatus === 'fulfilled') {
      setActiveType(allFaqTypeList[0][tB('name')])
    }
  }, [])
  useEffect(() => {
    fun()
  }, [allTypeList, allTypeList])
  return (
    <Box width={854} margin="0 auto" className={classes.root}>
      <Helmet>
        <meta name="description" content={t('seoDescription.faq')}/>
        <title>{t('seoTitle.faq')}</title>
      </Helmet>
      <TopStickyBar>
        <Box width={128} margin="0 auto" color="#000" fontWeight={600} fontSize={26} mt={8}>
          {t('glossary.faq')}
        </Box>
        {allFaqList?.length > 0 && (
          <Box padding={3}>
            <Box backgroundColor="none" margin="0 auto" width={630} mb={8}>
              <FaqSearch
                changeclearbtn={changeclearbtn}
                clearbtn={clearbtn}
                data={allFaqList}
                setSearchResult={handleSearchResult}
                changeselectShow={changeselectShow}
              />
            </Box>
            {selectShow ? (
              <Box>
                <Bar />
              </Box>
            ) : (
              ''
            )}
          </Box>
        )}
      </TopStickyBar>
      <Box pb={18}>
        <Box>
          {faqList?.length > 0 && faqList?.find((faq) => faq.status) && selectShow ? (
            faqList
              ?.filter((faq) => faq[tB('typeName')] === activeType || !activeType)
              ?.map((faq) => (
                <FaqItem
                  key={faq.id}
                  id={faq.id}
                  question={faq[tB('question')]}
                  content={faq[tB('content')]}
                  onChange={handleChange}
                  activePanel={activePanel}
                />
              ))
          ) : faqList?.length > 0 && faqList?.find((faq) => faq.status) && !selectShow ? (
            <Box>
              <Box style={{ fontSize: '16px' }} ml={2.5}>
                <Trans i18nKey="faq.list_filter">
                  .
                  <span style={{ fontSize: '16px', fontWeight: 600, marginLeft: '6px', marginRight: '6px' }}>
                    {{ name: classificationFaqList.length }}條
                  </span>
                  .
                </Trans>
                <Trans i18nKey="faq.list_filter_contain">{{ query: query }}</Trans>
              </Box>
              {/* test('should first', () => { second }) */}
              {classificationFaqList?.classificationFaqList?.map((item) =>
                item.list.length > 0 ? (
                  <Box key={item?.id}>
                    <Box className={classes.title}>{item?.label}</Box>
                    {item?.list?.map((faq) => (
                      <FaqItem
                        key={faq.questionType}
                        id={faq.id}
                        question={faq[tB('question')]}
                        content={faq[tB('content')]}
                        onChange={handleChange}
                        activePanel={activePanel}
                      />
                    ))}
                  </Box>
                ) : (
                  ''
                ),
              )}
            </Box>
          ) : (
            <FaqLoading
              changeclearbtn={changeclearbtn}
              clearbtn={clearbtn}
              title={allFaqList}
              status={faqListStatus}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default FAQ
